// ? see https://vuejs.org/api/application.html#app-config-errorhandler

import DynatracePlugin from '@/plugins/dynatracePlugin';
import type { ComponentPublicInstance } from 'vue';

export const vueErrorHandler = (
  err: unknown,
  instance: ComponentPublicInstance | null,
  info: string
) => {
  // handle uncaught errors propagating from within the application.
  try {
    // eslint-disable-next-line no-console
    console.error('🚀 ~ Vue uncaught error:', err);
    // eslint-disable-next-line no-console
    console.error('🚀 ~ Vue uncaught error info:', info);
    // eslint-disable-next-line no-console
    console.error('🚀 ~ Vue uncaught error component instance:', instance?.$options.name);
    DynatracePlugin.reportCustomError(
      'PC2_VUE_ERR',
      `message: ${err}, comp: ${instance?.$options.name}, ${info}`
    );
  } catch (_error) {
    /* empty */
  }
};

window.addEventListener('unhandledrejection', (event) => {
  // eslint-disable-next-line no-console
  console.error('Error occurred:', event.reason);
});
